<template>
<div class="pagi_container">
  <div>Page {{value}} of {{pageCount}}</div>
  <ul :class="paginationClasses.ul" class="">
    
    <li
      v-if="paginationLabels.prev"
      :class="`${paginationClasses.li} ${hasFirst ? paginationClasses.liDisable : ''}`"
    >
      <button
        @click="prev"
        :disabled="hasFirst"
        :class="`${paginationClasses.button} ${hasFirst ? paginationClasses.buttonDisable : ''}`"
        v-html="paginationLabels.prev"
        style="font-weight:bold"
      ></button>
    </li>

    <li
      v-for="page in items"
      :key="page.label"
      :class="`${paginationClasses.li} ${page.active ? paginationClasses.liActive : ''} ${page.disable ? paginationClasses.liDisable : ''}`"
    >
      <span
        v-if="page.disable"
        :class="`${paginationClasses.button} ${paginationClasses.buttonDisable}`"
        style="background-color:#ECECEC;border:none"
      >
        ...
      </span>
      <button
        v-else
        @click="goto(page.label)"
        :class="`${paginationClasses.button} ${page.active ? paginationClasses.buttonActive : ''}`"
      >
        {{ page.label }}
      </button>
    </li>

    <li
      v-if="paginationLabels.next"
      :class="`${paginationClasses.li} ${hasLast ? paginationClasses.liDisable : ''}`"
    >
      <button
        @click="next"
        :disabled="hasLast"
        :class="`${paginationClasses.button} ${hasLast ? paginationClasses.buttonDisable : ''}`"
        v-html="paginationLabels.next"
        style="font-weight:bold"
      ></button>
    </li>
  </ul>
  </div>
</template>

<script>
  const defaultClasses = {
    ul: 'pagination',
    // li: 'pagination-item',
    buttonActive: 'pagination-link--active',
    buttonDisable: 'pagination-link--disable',

    li: 'page-item',
    liActive: 'active',
    liDisable: 'disabled',
    button: 'page-link'
  }

  const defaultLabels = {
    first: '&laquo;',
    prev: '<',
    next: '>',
    last: '&raquo;'
  }

  export default {
    name:'Pagination',
    props: {
      value: {  // current page
        type: Number,
        required: true
      },
      pageCount: { // page numbers
        type: Number,
        required: true
      },
      classes: {
        type: Object,
        required: false,
        default: () => ({})
      },
      labels: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },

    data() {
      return {
        paginationClasses: {
          ...defaultClasses,
          ...this.classes
        },
        paginationLabels: {
          ...defaultLabels,
          ...this.labels
        }
      }
    },

    mounted() {
      if (this.value > this.pageCount) {
        this.$emit('input', this.pageCount)
      }
    },

    computed: {
      items() {
        let valPrev = this.value > 1 ? (this.value - 1) : 1 // for easier navigation - gives one previous page
        let valNext = this.value < this.pageCount ? (this.value + 1) : this.pageCount // one next page
        let extraPrev = valPrev === 3 ? 2 : null
        let extraNext = valNext === (this.pageCount - 2) ? (this.pageCount - 1) : null
        let dotsBefore = valPrev > 3 ? 2 : null
        let dotsAfter = valNext < (this.pageCount - 2) ? (this.pageCount - 1) : null

        let output = []

        for (let i = 1; i <= this.pageCount; i += 1) {
          if ([1, this.pageCount, this.value, valPrev, valNext, extraPrev, extraNext, dotsBefore, dotsAfter].includes(i)) {
            output.push({
              label: i,
              active: this.value === i,
              disable: [dotsBefore, dotsAfter].includes(i)
            })
          }
        }

        return output
      },

      hasFirst() {
        return (this.value === 1)
      },

      hasLast() {
        return (this.value === this.pageCount)
      },
    },

    watch: {
      value: function () {
        this.$emit('change')
      }
    },

    methods: {
      first() {
        if (!this.hasFirst) {
          this.$emit('input', 1)
        }
      },

      prev() {
        if (!this.hasFirst) {
          this.$emit('input', (this.value - 1))
        }
      },

      goto(page) {
        this.$emit('input', page)
      },

      next() {
        if (!this.hasLast) {
          this.$emit('input', (this.value + 1))
        }
      },

      last() {
        if (!this.hasLast) {
          this.$emit('input', this.pageCount)
        }
      },
    }
  }
</script>
<style scoped>
.pagi_container{
  height: 38px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  background-color:#ECECEC;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  position: relative;
  left: 0px;
  z-index: 0;
}
div{
  position: absolute;
  left:36px;
  color:#6D6E71;
}
ul{
  margin-bottom: 0px;

}
button{
  color:#6D6E71;
  background-color:#ECECEC;
  border: none;
  font-weight: bold;
}

.page-item.disabled .page-link{
   background-color:#ECECEC;
   border: none;
}
.page-item:last-child .page-link{
  border-top-right-radius: 0px;
  border-bottom-right-radius:0px;
}
.page-item:first-child .page-link {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>